import { externalNetworkClient } from '@terra/shared-rest-clients-external-network';
import type {
  AddExternalNetworkDomainsDto,
  AddExternalNetworkNetblocksDto,
  DomainListQueryDto,
  ExternalNetworkContract,
  NetBlockListQueryDto,
  Scope,
} from '@terra/shared-contracts-external-network';
import { tenantAwareApiWrapper, withOrchestratorClient } from './api-core';

export const externalNetworkScopeApi = {
  listScopeDomains: ({
    surfaceId,
    query,
  }: {
    surfaceId: string;
    query: DomainListQueryDto;
  }) =>
    tenantAwareApiWrapper<typeof ExternalNetworkContract.listDomains>({
      endpointFn: (headers) =>
        externalNetworkClient.listDomains({
          params: { surfaceId },
          query,
          ...withOrchestratorClient(headers),
        }),
    }),

  listScopeNetblocks: ({
    surfaceId,
    query,
  }: {
    surfaceId: string;
    query: NetBlockListQueryDto;
  }) =>
    tenantAwareApiWrapper<typeof ExternalNetworkContract.listNetblocks>({
      endpointFn: (headers) =>
        externalNetworkClient.listNetblocks({
          params: { surfaceId },
          query,
          ...withOrchestratorClient(headers),
        }),
    }),

  updateDomainScope: ({
    surfaceId,
    domainId,
    scope,
  }: {
    surfaceId: string;
    domainId: string;
    scope: Scope;
  }) =>
    tenantAwareApiWrapper<typeof ExternalNetworkContract.updateDomain>({
      endpointFn: (headers) =>
        externalNetworkClient.updateDomain({
          params: { surfaceId, domainId },
          body: { scope },
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  updateNetblockScope: ({
    surfaceId,
    netblockId,
    scope,
  }: {
    surfaceId: string;
    netblockId: string;
    scope: Scope;
  }) =>
    tenantAwareApiWrapper<typeof ExternalNetworkContract.updateNetblock>({
      endpointFn: (headers) =>
        externalNetworkClient.updateNetblock({
          params: { surfaceId, netblockId },
          body: { scope },
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  addScopeDomains: ({
    surfaceId,
    dto,
  }: {
    surfaceId: string;
    dto: AddExternalNetworkDomainsDto;
  }) =>
    tenantAwareApiWrapper<typeof ExternalNetworkContract.addDomains>({
      endpointFn: (headers) =>
        externalNetworkClient.addDomains({
          params: { surfaceId },
          body: dto,
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  addScopeNetblocks: ({
    surfaceId,
    dto,
  }: {
    surfaceId: string;
    dto: AddExternalNetworkNetblocksDto;
  }) =>
    tenantAwareApiWrapper<typeof ExternalNetworkContract.addNetblocks>({
      endpointFn: (headers) =>
        externalNetworkClient.addNetblocks({
          params: { surfaceId },
          body: dto,
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),
};
